import React, { createRef } from 'react';
import { IonModal, IonSelect, IonSelectOption, IonButton, IonTextarea, IonInput, IonActionSheet, IonBackButton, IonButtons, IonListHeader, IonCardHeader, IonCardContent, IonCardTitle, IonCardSubtitle, IonCard, IonFab, IonFabButton, IonIcon, IonContent, IonHeader, IonItem, IonLabel, IonList, IonPage, IonTitle, IonToolbar, withIonLifeCycle } from '@ionic/react';
import '../styles/ExportImportModal.scss';
import '../styles/Flashcard.scss';
import '../styles/PrintingModal.scss';
import Storage from '../Storage';
import Utilities from '../Utilities';
import SQLStorage from '../SQLStorage';
import { close, help, helpCircle } from 'ionicons/icons'
import store from '../state/store';
import { updatedSetsSet } from '../state/actions/UpdatedSets';
import { PDFDownloadLink, Document, Page, Text, View, StyleSheet, PDFViewer, BlobProvider, pdf, Image, Font, Link } from '@react-pdf/renderer';
import printImg from '../images/print.png';
import CncFmsLogo from '../images/cnc-fms-logo.png';

import { Device } from '@capacitor/device';
import { Share } from '@capacitor/share';
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';

const TERM_DEF_WIDTHS = ["10% - 90%", "20% - 80%", "30% - 70%", "40% - 60%", "50% - 50%", "60% - 40%", "70% - 30%", "80% - 20%", "90% - 10%"];
const FONT_SIZES = ["8px", "10px", "12px", "14px", "16px", "20px"];
const BORDERS = ["Solid", "Dashed", "Hidden"];
const MARGINS = ["0px", "10px", "15px", "20px", "25px", "30px", "35px", "40px", "45px", "50px"];
const PADDINGS = ["0px", "2px", "4px", "6px", "8px"];
const ROW_HEIGHT = ["auto", "40px", "50px","60px","70px","80px","90px","100px","110px","120px","130px","140px","150px","160px","170px","180px","190px","200px"];

class PrintingModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            loading: false,
            termDefWidth: 2,
            fontSize: 2,
            margin: 4,
            border: 1,
            padding: 0,
            rowHeight: 0,
            deviceInfo: {},
            cncClickCount: 0,
            cncBranded: localStorage.getItem("cncBranding") === "true" || window.location.href.indexOf("source=cnc-print") !== -1
        }
    }

    async componentDidMount() {
        let deviceInfo = await Device.getInfo();
        this.setState({ deviceInfo: deviceInfo })
    }

    async componentDidUpdate(nextProps) {
        if (nextProps.cards && window.location.href.indexOf("mcw=true") === -1 && window.location.href.indexOf("source=cnc-print") !== -1 && !this.state.loading) {
            this.print(
                window.location.href.indexOf("sample=true") !== -1,
                window.location.href.indexOf("externalsource=") !== -1 ? (window.location.href.split("externalsource=").pop().split("&").shift()) : undefined,
                window.location.href.indexOf("fmslink=true") !== -1,
                window.location.href.indexOf("mcw=true") !== -1,
            )
        }
        if (window.location.href.indexOf("mcw=true") !== -1 && this.state.termDefWidth !== 4) {
            this.setState({
                termDefWidth: 4,
                fontSize: 0,
                margin: 2,
                border: 1,
                padding: 1,
            })
        }
    }

    // TODO support for Japanese / Chinese...
    print = async (onlySample, externalSource, showFMSLink, mcwSource) => {

        const FONT_DOMAIN = 'https://rococo-caramel-28ebff.netlify.app/';

        this.setState({ loading: true })

        // Font.register({
        //     family: "Mukta",
        //     fonts: [
        //         { src: 'https://cdn.jsdelivr.net/npm/@typopro/web-ek-mukta@3.4.9/TypoPRO-EkMukta-Light.ttf', fontWeight: 300 },
        //         { src: 'https://cdn.jsdelivr.net/npm/@typopro/web-ek-mukta@3.4.9/TypoPRO-EkMukta-SemiBold.ttf', fontWeight: 600 }
        //     ]
        // });
    
        const termLangCode = Utilities.getKeyByValue(window.globalVars.LANGUAGE_CODES, this.props.set.term);
        const defLangCode = Utilities.getKeyByValue(window.globalVars.LANGUAGE_CODES, this.props.set.definition);

        // onlySample = false;

        const FONT_FAMILY_DEFAULT = "Noto Sans";
        const FONT_FAMILY_TERM = ["ko", "ar", "vi", "hi", "ru", "uk", "el", "he", "ja", "zh"].indexOf(termLangCode) !== -1 ? termLangCode : "Noto Sans"
        const FONT_FAMILY_DEF = ["ko", "ar", "vi", "hi", "ru", "uk", "el", "he", "ja", "zh"].indexOf(defLangCode) !== -1 ? defLangCode : "Noto Sans"

        console.log(termLangCode + " ------------- " + defLangCode + " "+ FONT_FAMILY_DEF);

        Font.register({
            family: "Noto Sans",
            fonts: [
                { src: FONT_DOMAIN + 'noto-sans-v27-latin-ext-300.ttf', fontWeight:300 },
                { src: FONT_DOMAIN + 'noto-sans-v27-latin-ext-600.ttf', fontWeight: 600 }
            ]
        });

        Font.register({
            family: "ko",
            fonts: [
                { src: FONT_DOMAIN + 'NotoSansKR-Regular.ttf', fontWeight:300 },
                { src: FONT_DOMAIN + 'NotoSansKR-Regular.ttf', fontWeight: 600 }
            ]
        });

        Font.register({
            family: "ar",
            fonts: [
                { src: FONT_DOMAIN + 'noto-sans-arabic-v18-arabic-300.ttf', fontWeight:300 },
                { src: FONT_DOMAIN + 'noto-sans-arabic-v18-arabic-600.ttf', fontWeight: 600 }
            ]
        });

        Font.register({
            family: "vi",
            fonts: [
                { src: FONT_DOMAIN + 'noto-sans-v27-vietnamese-300.ttf', fontWeight:300 },
                { src: FONT_DOMAIN + 'noto-sans-v27-vietnamese-600.ttf', fontWeight: 600 }
            ]
        });

        Font.register({
            family: "hi",
            fonts: [
                { src: FONT_DOMAIN + 'noto-sans-v27-devanagari-300.ttf', fontWeight:300 },
                { src: FONT_DOMAIN + 'noto-sans-v27-devanagari-600.ttf', fontWeight: 600 }
            ]
        });

        Font.register({
            family: "ru",
            fonts: [
                { src: FONT_DOMAIN + 'noto-sans-v27-cyrillic-300.ttf', fontWeight:300 },
                { src: FONT_DOMAIN + 'noto-sans-v27-cyrillic-300.ttf', fontWeight: 600 }
            ]
        });

        Font.register({
            family: "uk",
            fonts: [
                { src: FONT_DOMAIN + 'noto-sans-v27-cyrillic-300.ttf', fontWeight:300 },
                { src: FONT_DOMAIN + 'noto-sans-v27-cyrillic-300.ttf', fontWeight: 600 }
            ]
        });

        Font.register({
            family: "el",
            fonts: [
                { src: FONT_DOMAIN + 'noto-sans-v27-greek-300.ttf', fontWeight:300 },
                { src: FONT_DOMAIN + 'noto-sans-v27-greek-600.ttf', fontWeight: 600 }
            ]
        });

        Font.register({
            family: "he",
            fonts: [
                { src: FONT_DOMAIN + 'noto-sans-hebrew-v38-hebrew-300.ttf', fontWeight:300 },
                { src: FONT_DOMAIN + 'noto-sans-hebrew-v38-hebrew-600.ttf', fontWeight: 600 }
            ]
        });

        Font.register({
            family: "ja",
            fonts: [
                { src: FONT_DOMAIN + 'Nasu-Regular.ttf', fontWeight:300 },
                { src: FONT_DOMAIN + 'Nasu-Regular.ttf', fontWeight: 600 }
            ]
        });

        Font.register({
            family: "zh",
            fonts: [
                { src: FONT_DOMAIN + '站酷仓耳渔阳体-W03.ttf', fontWeight:300 },
                { src: FONT_DOMAIN + '站酷仓耳渔阳体-W03.ttf', fontWeight: 600 }
            ]
        });
    
        Utilities.trackEvent("Flashcard", "Flashcard Print", this.state.termDefWidth + "|" + this.state.fontSize + "|" + this.state.margin + "|" + this.state.border + "|" + this.state.padding + "|" + this.state.rowHeight, this.props.cards.length);

        let MyDoc = (
            <Document>
                <Page style={{ padding: MARGINS[this.state.margin] }}>
                    { this.props.cards.map((item, i) => {
                        if (!window.activated && i > 20 /* && !this.state.cncBranded*/) return null;
                        return (
                            <View key={i} style={{ padding: PADDINGS[this.state.padding] + " 0px " + PADDINGS[this.state.padding] + " 0px", display: 'flex', flexWrap: 'wrap', flexDirection: 'row', justifyContent: 'space-between', borderBottom: this.state.border === 0 ? '1px solid #999' : this.state.border === 1 ? '1px dashed #999' : 'none' }} wrap={false}>
                                <Text style={{ height: ROW_HEIGHT[this.state.rowHeight], fontSize: FONT_SIZES[this.state.fontSize], fontWeight: 600, margin: 0, width: TERM_DEF_WIDTHS[this.state.termDefWidth].split(" - ")[0], fontFamily: FONT_FAMILY_TERM }}>{item.term}</Text>
                                <Text style={{ fontSize: FONT_SIZES[this.state.fontSize], fontWeight: 300, margin: 0, width: TERM_DEF_WIDTHS[this.state.termDefWidth].split(" - ")[1], paddingLeft: 20, fontFamily: FONT_FAMILY_DEF }}>{item.definition}</Text>
                            </View>
                        )
                    }) }
                    { (!window.activated && this.props.cards.length > 20 && !this.state.cncBranded) &&
                        <View style={{ marginTop: 15 }}>
                            <Text style={{ fontSize: '18px', fontWeight: 600, margin: 0, textAlign: "center", fontFamily: FONT_FAMILY_DEFAULT }}>{window.ln.printProAlert}</Text>
                        </View>
                    }
                </Page>
            </Document>
          );

          if (this.state.cncBranded) {
            
            console.log("Printing external " + onlySample + " " + externalSource + " " + showFMSLink);

            // Sample with cnc link + fms root link ---- practical phrases 18k (free)
            // http://localhost:8100/set/B?source=cnc-print&sample=true&externalsource=https://chillnstudy.com/2022-04-02-english-at-the-restaurant&fmslink=false

            // Full with cnc link + fms set link --- Like posts
            // http://localhost:8100/set/B?source=cnc-print&sample=false&externalsource=https://chillnstudy.com/2022-04-02-english-at-the-restaurant&fmslink=true

            // Full with cnc link + fms root link --- practical phrases 18k (pro)
            // http://localhost:8100/set/B?source=cnc-print&sample=false&externalsource=https://chillnstudy.com/2022-04-02-english-at-the-restaurant&fmslink=false

            let headerLink = showFMSLink ? "https://flashcardsmadesimple.com/set/" + this.props.set.viewSecret : "https://flashcardsmadesimple.com"
            let headerName = showFMSLink ? this.props.set.name : "Study more on";

            if (mcwSource) {
                headerLink = "https://mostcommonwords.app";
                headerName = "Most Common Words";
            }

            MyDoc = (
                <Document>
                    <Page style={{ padding: MARGINS[this.state.margin] }}>
                        <View style={{ padding: PADDINGS[this.state.padding] + " 0px " + PADDINGS[this.state.padding] + " 0px", display: 'flex', flexWrap: 'wrap', flexDirection: 'row', justifyContent: 'space-between', borderBottom: this.state.border === 0 ? '1px solid #999' : this.state.border === 1 ? '1px dashed #999' : 'none' }} wrap={false}>
                            <Image src={CncFmsLogo} style={{ width: '160mm', display: 'block', margin: 'auto' }} />
                            { (headerLink) &&
                                <Link src={headerLink} style={{ textAlign: 'center', height: ROW_HEIGHT[this.state.rowHeight], fontSize: FONT_SIZES[this.state.fontSize], fontWeight: 700, margin: '12px 0 16px 0', fontFamily: FONT_FAMILY_DEFAULT }}>{headerName} {headerLink}</Link>
                            }
                        </View>
                        { this.props.cards.map((item, i) => {
                            if (!window.activated && i > 70 && onlySample) return null; // TODO increase
                            return (
                                <View key={i} style={{ padding: PADDINGS[this.state.padding] + " 0px " + PADDINGS[this.state.padding] + " 0px", display: 'flex', flexWrap: 'wrap', flexDirection: 'row', justifyContent: 'space-between', borderBottom: this.state.border === 0 ? '1px solid #999' : this.state.border === 1 ? '1px dashed #999' : 'none' }} wrap={false}>
                                    <Text style={{ height: ROW_HEIGHT[this.state.rowHeight], fontSize: FONT_SIZES[this.state.fontSize], fontWeight: 600, margin: 0, width: TERM_DEF_WIDTHS[this.state.termDefWidth].split(" - ")[0], fontFamily: FONT_FAMILY_TERM }}>{item.term}</Text>
                                    <Text style={{ fontSize: FONT_SIZES[this.state.fontSize], fontWeight: 300, margin: 0, width: TERM_DEF_WIDTHS[this.state.termDefWidth].split(" - ")[1], paddingLeft: 20, fontFamily: FONT_FAMILY_DEF }}>{item.definition}</Text>
                                </View>
                            )
                        }) }
                        <View style={{ marginTop: 15 }}>
                            { (showFMSLink) &&
                                <Text style={{ fontSize: '14px', fontWeight: 400, margin: 0, textAlign: "center", fontFamily: FONT_FAMILY_DEFAULT }}>
                                    View all phrases at:{' '}
                                    <Link style={{ display: 'block', textDecoration: 'underline' }} src={headerLink}>{headerLink}</Link>
                                </Text>
                            }
                            { (externalSource && onlySample) &&
                                <Text style={{ fontSize: '14px', fontWeight: 400, margin: 0, textAlign: "center", fontFamily: FONT_FAMILY_DEFAULT }}>
                                    Purchase the whole PDF at:{' '}
                                    <Link style={{ display: 'block', textDecoration: 'underline' }} src={externalSource}>{externalSource}</Link>
                                </Text>
                            }
                            { (externalSource && !onlySample && window.location.href.indexOf("mcw=true") === -1) &&
                                <Text style={{ fontSize: '14px', fontWeight: 400, margin: 0, textAlign: "center", fontFamily: FONT_FAMILY_DEFAULT }}>
                                    PDF Downloaded from: {' '}
                                    <Link style={{ display: 'block', textDecoration: 'underline' }} src={externalSource}>{externalSource}</Link>
                                </Text>
                            }
                        </View>
                    </Page>
                </Document>
              );
          }

          console.log(MyDoc);

          const blob = await pdf(MyDoc).toBlob();
          console.log(blob)
          const fileName = this.state.cncBranded ? ( (onlySample ? "[Sample] " : "") + "[" + this.props.set.term + "-" + this.props.set.definition + "] " + this.props.set.name ) : this.props.set ? (this.props.set.name + '.pdf') : 'print.pdf'

        if (this.state.deviceInfo.platform === "ios" || this.state.deviceInfo.platform === "android" ) {
            await new Promise((resolve, reject) => {
                var reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = async function() {

                    var base64data = reader.result.replace("data:application/pdf;base64,", "");

                    await Filesystem.writeFile({ path: fileName, data: base64data, directory: Directory.Data /*, encoding: FilesystemEncoding.UTF8*/  }).catch(e => {
                        console.error("Failed to write file", e)
                        window.toast(e.message, "error");
                        this.setState({ loading: null });
                        resolve();
                    })

                    let uri = await Filesystem.getUri({ directory: Directory.Data, path: fileName });

                    Share.share({
                        files: [uri.uri],
                        title: fileName,
                    })
                }
            })
        } else {
            // if (window.location.href.indexOf("source=cnc-print") !== -1) {
            //     var reader = new FileReader(); 
            //     reader.readAsDataURL(blob); 
            //     reader.onloadend = function(a, b) {
            //         console.log(a.srcElement.result)
            //         const p = document.createElement('p');
            //         p.innerText = a.srcElement.result;
            //         p.id = "pdf-res";
            //         document.body.append(p);
            //     }
            // } else {
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = fileName
                document.body.append(link);
                link.click();
                link.remove();
                console.log(link);
                setTimeout(() => URL.revokeObjectURL(link.href), 7000);
            // }
        }

    }

    render() {
        return (
            <IonModal
                isOpen={this.props.open}
                swipeToClose={false}
                ref={this.entryModalRef}
                presentingElement={this.props.presentingElement ? this.props.presentingElement.current : null}
                onDidDismiss={() => {
                    if (!this.state.loading)
                        this.props.onClose();
                }}
                mode={"ios"}
           >
                <div className="swipeable-drawer-body" data-drawer="export-import" className="export-import-modal">
                    <IonHeader>
                        <IonToolbar>
                            <IonTitle>{window.ln.print}</IonTitle>
                            <IonButtons slot="end">
                                <IonIcon style={{ width: 24, height: 24, marginRight: 8, marginTop: -3, color: "#333" }} icon={close} onClick={() => { this.props.onClose() }} />
                            </IonButtons>
                        </IonToolbar>
                    </IonHeader>
                    <div className="options">
                        <div className="print-diy" onClick={() => {
                            // let clicks = this.state.cncClickCount;
                            // console.log(clicks)
                            // if (clicks > 2) {
                            //     this.setState({
                            //         cncBranded: true
                            //     })
                            // } else {
                            //     this.setState({
                            //         cncClickCount: clicks + 1
                            //     })
                            // }
                        }}>
                            <h2>{window.ln.printDIYLabel}</h2>
                            <img src={printImg} />
                        </div>
                        <IonList>
                            <IonItem>
                                <IonLabel>{window.ln.printWidth}</IonLabel>
                                <IonSelect onIonChange={ async (i) => { this.setState({ termDefWidth: i.detail.value }) }} value={this.state.termDefWidth || 0}>
                                    { TERM_DEF_WIDTHS.map((item, i) => {
                                        return (<IonSelectOption key={i} value={i}>{item}</IonSelectOption>)
                                    }) }
                                </IonSelect>
                            </IonItem>
                            <IonItem>
                                <IonLabel>{window.ln.printFont}</IonLabel>
                                <IonSelect onIonChange={ async (i) => { this.setState({ fontSize: i.detail.value }) }} value={this.state.fontSize || 0}>
                                    { FONT_SIZES.map((item, i) => {
                                        return (<IonSelectOption key={i} value={i}>{item}</IonSelectOption>)
                                    }) }
                                </IonSelect>
                            </IonItem>
                            <IonItem>
                                <IonLabel>{window.ln.printBorder}</IonLabel>
                                <IonSelect onIonChange={ async (i) => { this.setState({ border: i.detail.value }) }} value={this.state.border || 0}>
                                    { BORDERS.map((item, i) => {
                                        return (<IonSelectOption key={i} value={i}>{item}</IonSelectOption>)
                                    }) }
                                </IonSelect>
                            </IonItem>
                            <IonItem>
                                <IonLabel>{window.ln.printMargin}</IonLabel>
                                <IonSelect onIonChange={ async (i) => { this.setState({ margin: i.detail.value }) }} value={this.state.margin || 0}>
                                    { MARGINS.map((item, i) => {
                                        return (<IonSelectOption key={i} value={i}>{item}</IonSelectOption>)
                                    }) }
                                </IonSelect>
                            </IonItem>
                            <IonItem>
                                <IonLabel>{window.ln.printPadding}</IonLabel>
                                <IonSelect onIonChange={ async (i) => { this.setState({ padding: i.detail.value }) }} value={this.state.padding || 0}>
                                    { PADDINGS.map((item, i) => {
                                        return (<IonSelectOption key={i} value={i}>{item}</IonSelectOption>)
                                    }) }
                                </IonSelect>
                            </IonItem>
                            <IonItem>
                                <IonLabel>{window.ln.printMinHeight}</IonLabel>
                                <IonSelect onIonChange={ async (i) => { this.setState({ rowHeight: i.detail.value }) }} value={this.state.rowHeight || 0}>
                                    { ROW_HEIGHT.map((item, i) => {
                                        return (<IonSelectOption key={i} value={i}>{item}</IonSelectOption>)
                                    }) }
                                </IonSelect>
                            </IonItem>
                        </IonList>
                    </div>
                </div>
                <IonFab style={{ width: '100%' }} vertical="bottom" horizontal="start" slot="fixed">
                    <IonFabButton disabled={this.state.loading} onClick={ async () => { 
                        if (this.props.cards && window.location.href.indexOf("source=cnc-print") !== -1 && !this.state.loading) {
                            this.print(
                                window.location.href.indexOf("sample=true") !== -1,
                                window.location.href.indexOf("externalsource=") !== -1 ? (window.location.href.split("externalsource=").pop().split("&").shift()) : undefined,
                                window.location.href.indexOf("fmslink=true") !== -1,
                                window.location.href.indexOf("mcw=true") !== -1,
                            )
                        } else {
                            this.print();
                        }
                    }} style={{ width: 'calc(100% - 20px)', '--border-radius': '56px' }}>
                        <IonLabel style={{ marginLeft: 8, fontWeight: 600, position: "relative", top: -1 }}>{!this.state.loading ? window.ln.print : window.ln.preparingFile + " ..." }</IonLabel>
                    </IonFabButton>
                </IonFab>
           </IonModal>
        );
    }

};


export default withIonLifeCycle(PrintingModal);
